import { Injectable } from '@angular/core';
import { AppService } from '../app.service';
import ForgetPasswordModel from '../components/forget-password/forget-password.model';
import { HttpClient } from '@angular/common/http';
import RecoveryPasswordModel from '../components/recovery-password/recovery-password.model';

@Injectable()
export class ForgetPasswordService extends AppService<ForgetPasswordModel> {

  constructor(http: HttpClient) {
    super(http);
  }

  async requestRecoveryPassword(cpfOuEmail: ForgetPasswordModel) {
    const result = await this.postAsync('Account/RequestRecoveryPassword', cpfOuEmail);
    return result;
  }

  async recoveryPassword(recoveryPassword: RecoveryPasswordModel) {
    const result = await this.postAsync('Account/RecoveryPassword', recoveryPassword);
    return result;
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/services/forgetPassword.service.ts